import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml, SafeUrl} from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) {
    }

    // tslint:disable-next-line:typedef
    transform(value): SafeHtml {
        if (value === undefined) return '';
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}

@Pipe({
    name: 'safeUrl',
    standalone: false
})
export class SafeUrlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) {
    }

    // tslint:disable-next-line:typedef
    transform(url): SafeUrl {
        return this.sanitized.bypassSecurityTrustResourceUrl(url);
    }
}
